import { c as _c } from "react/compiler-runtime";
import { Checkbox } from 'platform/components';
import { HEADER_CELL_BORDER_BOTTOM } from '../../../../constants/borderStyles';
import { SELECTION_COLUMN_WIDTH, SELECTION_TEST_ID_PREFIX } from '../../../../constants/selectionColumn';
import { useGridRows } from '../../../../store/selectors/useGridRows';
import { useSelectedRowIds } from '../../../../store/selectors/useSelectedRowIds';
import { useEagGridStore } from '../../../../store/useEagGridStore';
export type SelectAllCheckboxProps = {
  /** Sticky top offset in px. 0 when no group header row is shown; GROUP_HEADER_ROW_HEIGHT when visible. */
  stickyTop: number;
};
export function SelectAllCheckbox(props) {
  const $ = _c(13);
  const store = useEagGridStore();
  const selectedRowIds = useSelectedRowIds();
  const rows = useGridRows();
  const selectedCount = selectedRowIds.size;
  const totalCount = rows.length;
  const isAllSelected = totalCount > 0 && selectedCount === totalCount;
  const isIndeterminate = selectedCount > 0 && selectedCount < totalCount;
  let t0;
  if ($[0] !== isAllSelected || $[1] !== rows || $[2] !== store) {
    t0 = () => {
      if (isAllSelected) {
        store.deselectAll();
      } else {
        store.selectAll(rows.map(_temp));
      }
    };
    $[0] = isAllSelected;
    $[1] = rows;
    $[2] = store;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const handleToggleAll = t0;
  let t1;
  if ($[4] !== props.stickyTop) {
    t1 = {
      width: SELECTION_COLUMN_WIDTH,
      position: "sticky",
      top: props.stickyTop,
      left: 0,
      zIndex: "var(--z-content-loader)",
      ...HEADER_CELL_BORDER_BOTTOM
    };
    $[4] = props.stickyTop;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== handleToggleAll || $[7] !== isAllSelected || $[8] !== isIndeterminate) {
    t2 = <div className="flex items-center justify-center h-full"><Checkbox value={isAllSelected} isIndeterminate={isIndeterminate} onChange={handleToggleAll} data-testid={`${SELECTION_TEST_ID_PREFIX}-all`} /></div>;
    $[6] = handleToggleAll;
    $[7] = isAllSelected;
    $[8] = isIndeterminate;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== t1 || $[11] !== t2) {
    t3 = <th className="p-0 text-center select-none font-normal bg-white" style={t1}>{t2}</th>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}
function _temp(row) {
  return row.id;
}